import { getCookie } from "cookies-next";

import { ACCESS_TOKEN_COOKIE } from "~/utils/constants";
export const checkTransact = async (ssoid: string) => {
  try {
    const token = getCookie(ACCESS_TOKEN_COOKIE) as string;
    const url = `/v1/profiles/${ssoid}/status/transact`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Error in checkTransact - status: ${response.status}`);
    }

    return response.json();
  } catch (error) {
    throw new Error(`Error in checkTransact: ${error}`);
  }
};

/* Reviews that have not been snoozed prior, and are current */
export const getReviews = async (ssoid: string) => {
  try {
    const token = getCookie(ACCESS_TOKEN_COOKIE) as string;
    const url = `/v1/reviews/user/${ssoid}/current`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.json();
  } catch (error) {
    throw new Error(`Error in getReviews: ${error}`);
  }
};

interface IReviewSubmission {
  review_text: string;
  stars: number;
  would_you_book_again: boolean;
}

export const updateReview = async (
  reviewId: string,
  reviewSubmission: IReviewSubmission,
) => {
  try {
    const token = getCookie(ACCESS_TOKEN_COOKIE) as string;
    const url = `/v1/reviews/${reviewId}`;
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(reviewSubmission),
    });
    return response.json();
  } catch (error) {
    throw new Error(`Error in updateReview: ${error}`);
  }
};
